export default "__VITE_ASSET__6e3f709c__"